/** Styl komponenty message k tématu Erma */
export const MessageStyles = {
  borderRadius: '4px',
  borderWidth: 0,
  iconSize: '1rem',
  success: {
    background: 'var(--erma-green-50)',
    color: 'var(--erma-green-600)'
  },
  error: {
    background: 'color-mix(in srgb,var(--erma-red-50),transparent 5%)',
    color: 'var(--erma-red-600)'
  },
  warn: {
    background: 'color-mix(in srgb,var(--erma-yellow-50),transparent 5%)',
    color: 'var(--erma-yellow-900)',
  },
  info: {
    background: 'var(--erma-blue-200)',
    color: 'var(--erma-blue-600)',
  },
  content: {
    padding: '.8rem',
    gap: '1rem'
  },
  text: {
    fontSize: '1rem'
  }
};
